<!--TEST ASSESSMENT DETAILS-->
<div class="modal-body DetailScroll" id="tblpopupfreelancer">
 
  <div class="row">
    <div class="col-sm-12" id="tblVendorAllocation">
      <table class="tblBkinfo tblMain table table-bordered" width="100%">
        <tbody>
          <tr>
            <td class="main"><b>Freelancer Name</b></td>
            <td id="text_vendorname"></td>
            <td class="main"><b>Email</b></td>
            <td id="EmailId"></td>
          </tr>
          <tr>
            <td class="main"><b>Category</b></td>
            <td id="category"></td>
            <td class="main"><b>ArticleNo</b></td>
            <td id="Articleno"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-6">
      <br>
      <button type="button" class="btn btn-outline-primary waves-effect waves-light" (click)="downloadAssignedTestFile()"><i class="fa fa-download"></i> Assigned Test File</button>&nbsp;
      <button type="button" class="btn btn-outline-primary waves-effect waves-light" (click)="downloadUploadedTestFile()"><i class="fa fa-download"></i> Freelancer Uploaded File</button>&nbsp;
    </div>
    <div class="modal-emoji emoji-table">
      <div class="form-group">
        <div class="row" id="CopyeditingData">
          <div class="col-sm-12" id="tblVendorChecklist">
            <label>Checklist</label>
            <table class="tblBkinfo tblMain table table-bordered" id="tbl_checklist" width="100%">
              <thead>
                <tr class="main">
                  <th>S.No </th>
                  <th>Areas</th>
                  <th>FeedBack</th>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" id="tblVendor">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Results</label><em>*</em>
                <select class="form-control select2" type="number" id="Txt_Result">
                  <option value="">Select Result</option>
                  <option value="Pass">Pass</option>
                  <option value="Fail">Fail</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <label>Score</label><em>*</em>
              <input id="Txt_Score" type="number" class="form-control" placeholder="Select Score" autocomplete="off" min="0" />
            </div>
            <div class="col-sm-4">
              <label>Remarks</label><em>*</em>
              <input type="text" class="form-control" id="Txt_Remarks" placeholder="Select Remarks" maxlength="100" autocomplete="off" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-12" id="tblassessmentsummary">
          <label>Summary</label>
          <button class="btn btn-outline-info waves-effect waves-light proofingAddbtn" (click)="AddSummary()" style="float:right">
            <i class="fa fa-plus"></i>Add
          </button> &nbsp;
          <button type="button" (click)="DeleteSummay()" id="btnDeleteSummary" style="display:none">Add</button>
          <table id="tbl_summarylist" class="tblBkinfo tblMain table table-bordered" width="100%">
            <thead>
              <tr class="main">
                <th>S.No</th>
                <th>Issues</th>
                <th>Examples</th>
                <th style="width:10%">Page #</th>
                <th style="width: 5%;text-align:center;">Action</th>
                <td style='display:none' class='random'></td>
              </tr>
            </thead>
            <tbody>
              <!--<tr>
        <td style="text-align:center">1</td>
        <td><input id="Txt_Issue" type="text" class="form-control" placeholder="Enter the Issues" min="0" /></td>
        <td><input id="Txt_Examples" type="text" class="form-control" placeholder="Enter the Examples" maxlength="100" /></td>
        <td><input id="Txt_Page" type="number" class="form-control" placeholder="Enter the PageNo" min="0" /></td>

        <td style='width:5%'><input type='number' class='form-control' placeholder='Enter the PageNo' min='0'></td>

        <td style='width:5%;text-align:center;'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;text-align:center;' onclick=Delete(this);></i></td>
      </tr>-->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal footer -->
  

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideAssesment()">Cancel</button>
  <button type="submit" class="btn btn-outline-success waves-effect waves-light" (click)="Updateassessment()">Complete</button>
</div>
